import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export default createGlobalStyle`
    ${reset};
    *{
        @import url("https://fonts.googleapis.com/css?family=Noto+Sans+KR:400,700&display=swap&subset=korean");
        box-sizing:border-box;
    }
    *{
        box-sizing:border-box;
    }
    html {
    height: 100%
    }
    body {
    line-height:1.5;
    height: 100%;
    font-family: 'Noto Sans KR';
    }
    #root {
    height: 100%;
}
`;
